export default {
  fonts: {
    heading: 'RaptorV3Premium',
    body: 'RaptorV3Premium',
  },
};
